import { css } from 'linaria';

/*
  Fix for buttons, as they have different sizing rules in according to
  https://www.w3.org/TR/CSS22/visudet.html#block-replaced-width
 */
export const suggestionButton = css`
  width: calc(100% + var(--space-100));
  text-align: start;
`;

export const suggestion = css`
  display: block !important;
  padding: var(--space-75) var(--space-200) !important;
  border-width: 0;

  border-radius: 0 !important;

  &.active {
    --button-bg: var(--background-secondary);
    --button-hover-bg: var(--background-secondary);
  }
`;

export const suggestionText = css`
  white-space: normal !important;
`;

export const suggestionCaption = css`
  white-space: wrap;
  width: 100%;
`;

export const suggestionContentWrap = css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: var(--space-200);
  position: relative;
`;

export const suggestionIconWrap = css`
  display: flex;
  width: 40px;
  height: 40px;
  padding: var(--space-100);
  justify-content: center;
  align-items: center;
  border-radius: var(--rounding-m);
  border: 1px solid var(--control-minor);
`;

export const servicesSuggestionIcon = css`
  background-color: var(--service-light);
  align-self: flex-start;
`;

export const suggestionTextContentWrap = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--space-25);
  min-width: 0;
`;

export const categorySuggestionIcon = css`
  object-fit: contain;
  width: 40px;
  height: 40px;
  border-radius: var(--rounding-m);
`;

export const categorySuggestionIconLoading = css`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: var(--rounding-m);
  background: linear-gradient(
    90deg,
    var(--background-secondary),
    var(--background-primary),
    var(--background-secondary)
  );
  background-size: 50%;
  animation: progress 1s linear infinite;
`;
